import { blockTheme, hsl } from '@teach/ui'
import { cn } from '@/lib/utils'
import { UploadProgressBody } from './UploadProgressBody'
import { useSmoothProgress } from './useSmoothProgress'

interface Props {
  /** Сырой процент загрузки (`null` — не грузим, оверлея нет). */
  progress: number | null
  tone?: 'app' | 'canvas'
  size?: 'md' | 'sm'
}

const COLORS = {
  app: {
    bg: 'hsl(var(--background) / 0.85)',
    title: 'hsl(var(--foreground))',
    track: 'hsl(var(--muted))',
    fill: 'hsl(var(--brand))',
  },
  canvas: {
    bg: hsl(blockTheme.background, 0.85),
    title: hsl(blockTheme.foreground),
    track: hsl(blockTheme.primary, 0.15),
    fill: hsl(blockTheme.primary),
  },
}

/** Прогресс загрузки поверх места (пустого или с прежней картинкой), пока файл едет.
 *  Один вид на всю студию: картинки блоков, видео, баннер, маскоты, образцы стиля,
 *  обложка и картинки статьи. Родитель обязан быть `relative`. */
export const UploadProgressOverlay = ({ progress, tone = 'app', size = 'md' }: Props) => {
  const shown = useSmoothProgress(progress)
  if (shown === null) return null
  const c = COLORS[tone]
  return (
    <div
      className={cn(
        'absolute inset-0 z-10 flex items-center justify-center rounded-[inherit]',
        size === 'sm' ? 'px-2' : 'px-4',
      )}
      style={{ backgroundColor: c.bg }}
    >
      <UploadProgressBody percent={shown} colors={c} size={size} />
    </div>
  )
}
